import React, { useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { NextButton, PrevButton, usePrevNextButtons } from './EmblaCarouselArrowButtons';
import { useDotButton } from './EmblaCarouselDotButton';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { FETCH_TESTIMONIAL_API } from "../../Api";
import Autoplay from "embla-carousel-autoplay";
import sunSci from '../../../assets/sun_scien_logo.png';
import sunLab from '../../../assets/sun_lab_logo.png';
import infiWell from '../../../assets/infiwell.png';
import miaTeknosoft from '../../../assets/mia teknosoft logo.png';

const OPTIONS = { dragFree: true, loop: true };

const TestimonialsSection = () => {
    const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS, [Autoplay({ delay: 3000, reverse: true, stopOnInteraction: false })]);
    const [testimonials, setTestimonials] = useState([]);

    const wingsData = [
        { id: 1,  imageUrl: sunSci },
        { id: 2, imageUrl: sunLab },
        { id: 3,imageUrl: miaTeknosoft },
        { id: 4, imageUrl: infiWell },
    ];

    useEffect(() => {
        async function fetchTestimonialsFromServer() {
            try {
                const response = await fetch(FETCH_TESTIMONIAL_API);
                const testimonialsData = await response.json();
                setTestimonials(testimonialsData);
            } catch (error) {
                console.error("Error fetching testimonials:", error);
            }
        }
        fetchTestimonialsFromServer();
    }, []);

    const { selectedIndex, onDotButtonClick } = useDotButton(emblaApi);
    const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi);

    // Separate animation triggers
    const { ref: titleRef, inView: titleInView } = useInView({ triggerOnce: true, threshold: 0.2 });
    const { ref: carouselRef, inView: carouselInView } = useInView({ triggerOnce: true, threshold: 0.1 });

    return (
        <div ref={titleRef} className="bg-white text-black py-20  text-left">
            {/* Title Animation */}
 
            {testimonials.length > 3 && (
                           <div>
            <motion.h2
                className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6"
                initial={{ opacity: 0, y: 30 }}
                animate={titleInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <span className="text-green-800">See what all the talk is about! </span>
                <span className="text-gray-600 font-semibold">Hear it from our customers.</span>
            </motion.h2>


            <motion.div
                ref={carouselRef}
                initial={{ opacity: 0, y: 30 }}
                animate={carouselInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="embla py-12 relative z-10"
            >
                <div className="embla__viewport" ref={emblaRef}>
                    <div className="embla__container">
                        {testimonials.map((testimonial, index) => (
                            <div className="embla__slide" key={index}>
                                <div className="embla__parallax">
                                    <div className="embla__parallax__layer">
                                        <div
                                            key={index}
                                            className="relative p-4 md:p-6 rounded-[1rem] border border-gray-600 shadow-lg backdrop-blur-lg bg-white/70 flex flex-col space-y-6"
                                        >
                                            <p className="text-gray-800 text-sm md:text-md font-medium leading-relaxed">
                                                {testimonial.desc}
                                            </p>

                                            <div className="flex items-center space-x-2 border-t-2 pt-4">
                                                <img
                                                    src={testimonial.imgSrc}
                                                    alt={testimonial.name}
                                                    className="w-14 h-14 rounded-full object-cover border-2 border-gray-300"
                                                />

                                                <div>
                                                    <h4 className="text-gray-900 font-semibold text-sm">{testimonial.name}</h4>
                                                    <p className="text-gray-500 text-xs">
                                                        {testimonial.designation} @ {testimonial.organization}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="embla__controls">
                    <div className="embla__buttons">
                        <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
                        <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
                    </div>

                    <div className="flex -space-x-3 embla__dots">
                        {testimonials.slice(0, 3).map((testimonial, index) => (
                            <img
                                key={index}
                                src={testimonial.imgSrc}
                                alt={testimonial.name}
                                className={`w-10 h-10 rounded-full border-2 border-white embla__dot ${index === selectedIndex ? 'embla__dot--selected' : ''}`}
                                onClick={() => onDotButtonClick(index)}
                                style={{ zIndex: 10 - index }}
                            />
                        ))}
                    </div>
                </div>
            </motion.div>
            </div>
            )}


            {/* Trusted by Customers Section */}

<motion.div
    ref={titleRef}
    initial={{ opacity: 0, y: 30 }}
    animate={titleInView ? { opacity: 1, y: 0 } : {}}
    transition={{ duration: 0.8, ease: "easeOut" }}
    className="rounded-lg flex flex-col items-center w-full text-center space-y-8"
>
    <p className="font-semibold text-gray-900  pt-10
        text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-4xl 
        max-w-[100%] md:max-w-[100%] lg:max-w-[100%]">
        Join a growing community that values excellence and seamless experience.
    </p>

    <div className="flex flex-wrap justify-center gap-6 sm:gap-8 md:gap-10">
        {wingsData.map((wing) => (
            <div key={wing.id} className="p-2">
                <img
                    src={wing.imageUrl}
                    alt={`Logo ${wing.id}`}
                    className="object-contain w-28 h-12 sm:w-32 sm:h-14 md:w-36 md:h-16 " //filter grayscale
                />
            </div>
        ))}
    </div>
</motion.div>

        </div>
    );
};

export default TestimonialsSection;
